export const SIGN_IN_TEXT = "Sign in";
export const YES = true;
export const NO = false;
